<template>
  <div class="mobile-dashboard">
    <section class="weather-hero" :class="weatherClass">
      <div class="hero-header">
        <img class="logoSideApp" :src="dataCompany.urlImage" alt="" />
        <div class="nameCompany">
          <small>Bem-vindo</small>
          <span>{{ dataCompany.nome }}</span>
        </div>
      </div>

      <div v-if="weather.main" class="weather-content">
        <div class="weather-text">
          <span class="city">{{ weather.name }}</span>
          <span class="date">{{ formattedDate }}</span>
        </div>

        <div class="weather-summary">
          <div class="weather-symbol" aria-hidden="true">
            <b-icon-brightness-high-fill v-if="weatherIconType === 'sun'" />
            <b-icon-moon-stars-fill v-else-if="weatherIconType === 'moon'" />
            <b-icon-cloud-fill v-else-if="weatherIconType === 'cloud'" />
            <b-icon-cloud-rain-fill v-else-if="weatherIconType === 'rain'" />
            <b-icon-cloud-lightning-rain-fill v-else-if="weatherIconType === 'storm'" />
            <b-icon-cloud-haze-fill v-else-if="weatherIconType === 'mist'" />
            <b-icon-cloud-snow-fill v-else-if="weatherIconType === 'snow'" />
            <b-icon-cloud-sun-fill v-else />
          </div>
          <div>
            <div class="weather-temp-big">{{ Math.round(weather.main.temp) }}°</div>
            <div class="weather-desc">{{ weather.weather[0].description }}</div>
          </div>
        </div>

        <div class="weather-details">
          <span>
            <b-icon-droplet />
            {{ weather.main.humidity }}%
          </span>
          <span>
            <b-icon-wind />
            {{ weather.wind.speed }} km/h
          </span>
          <span>
            <b-icon-thermometer-half />
            {{ Math.round(weather.main.temp_max) }}°
          </span>
        </div>
      </div>

      <div v-else class="weather-loading">
        <b-spinner small />
        <p>{{ weatherMessage }}</p>
      </div>
    </section>

    <main class="main-content">
      <section>
        <div class="section-heading">
          <div>
            <h3 class="section-title">Visão Geral</h3>
            <span class="section-subtitle">Resumo do mês atual</span>
          </div>
        </div>

        <div class="kpi-scroll-container">
          <div class="kpi-card">
            <div class="kpi-header">
              <div class="icon-box green-bg">
                <img :src="Recepit" alt="" />
              </div>
              <span class="kpi-label">Receitas Emitidas (Mês)</span>
            </div>
            <b-spinner v-if="spinGeneral" small />
            <span class="kpi-value" v-else>{{ countFinalizado }}</span>
            <p class="kpi-footer">
              Média de {{ mediaDia }}
              {{ mediaDia > 1 ? "receitas" : "receita" }} por dia
            </p>
          </div>

          <div class="kpi-card">
            <div class="kpi-header">
              <div class="icon-box blue-bg">
                <img :src="Recepit" alt="" />
              </div>
              <span class="kpi-label">Receitas Emitidas (Hoje)</span>
            </div>
            <b-spinner v-if="spinGeneral" small />
            <span class="kpi-value" v-else>{{ countHoje }}</span>
            <p
              class="kpi-footer"
              :class="countHoje >= mediaDia ? 'success' : 'warning'"
            >
              {{ countHoje >= mediaDia ? "Você superou a média!" : "Abaixo da média diária" }}
            </p>
          </div>

          <div class="kpi-card">
            <div class="kpi-header">
              <div class="icon-box amber-bg">
                <img :src="Fiscal" alt="" />
              </div>
              <span class="kpi-label">Produtos</span>
            </div>
            <b-spinner v-if="spinGeneral" small />
            <span class="kpi-value" v-else>{{ totalProdutos }}</span>
            <p class="kpi-footer">Indicações deste mês</p>
          </div>

          <div class="kpi-card">
            <div class="kpi-header">
              <div class="icon-box teal-bg">
                <img :src="Group" alt="" />
              </div>
              <span class="kpi-label">Clientes</span>
            </div>
            <b-spinner v-if="spinGeneral" small />
            <span class="kpi-value" v-else>{{ totalClientes }}</span>
            <p class="kpi-footer success">{{ novosClientes }} novos este mês</p>
          </div>
        </div>
      </section>

      <section>
        <div class="section-heading">
          <div>
            <h3 class="section-title">Últimas Atualizações</h3>
            <span class="section-subtitle">Novidades do compêndio e sistema</span>
          </div>
        </div>

        <div class="updates-list">
          <div v-if="loading" class="updates-state">
            <b-spinner small />
            <span>Carregando atualizações...</span>
          </div>

          <button
            v-for="(item, index) in visibleUpdates"
            v-else
            :key="index"
            class="update-item"
            @click="abrirModalAtualizacao(item)"
          >
            <div class="update-date-pill">
              <span>{{ getUpdateDay(item.data) }}</span>
              <small>{{ getUpdateMonth(item.data) }}</small>
            </div>

            <div class="update-content">
              <div class="update-meta">
                <span :class="['update-tag', obterEstiloTipo(item.tipo).classe]">
                  {{ obterEstiloTipo(item.tipo).texto }}
                </span>
                <b-icon-chevron-right class="update-arrow" />
              </div>
              <p>{{ item.textoAtualizacao }}</p>
            </div>
          </button>

          <div v-if="!loading && updates.length === 0" class="updates-state">
            <span>Nenhuma atualização encontrada.</span>
          </div>
        </div>
      </section>

      <section>
        <div class="section-heading">
          <div>
            <h3 class="section-title">Rankings</h3>
            <span class="section-subtitle">Mais movimentados no mês</span>
          </div>
        </div>

        <div class="ranking-card">
          <div class="ranking-title">
            <img class="cash-icon" :src="Chart" alt="" />
            Top 5 - Culturas Prescritas (Mês)
          </div>
          <div
            class="contentTopAnything"
            v-if="spinGeneral"
            style="justify-content: center; padding: 20px 0"
          >
            <b-spinner />
          </div>
          <div class="contentTopAnything" v-else>
            <span
              v-for="(item, index) in topCulturas"
              :key="index"
              class="rowTopAnything"
            >
              <span class="rank-pos">#{{ index + 1 }}</span>
              <span class="rank-name">{{ item.nome.toLowerCase() }}</span>
              <span class="rank-total">{{ item.total }}</span>
            </span>
            <span v-if="topCulturas.length === 0" class="rowTopAnything empty">
              Nenhum dado encontrado
            </span>
          </div>
        </div>

        <div class="ranking-card">
          <div class="ranking-title">
            <img class="cash-icon" :src="Mega" alt="" />
            Ingredientes Ativos mais vendidos (Mês)
          </div>
          <div
            class="contentTopAnything"
            v-if="spinGeneral"
            style="justify-content: center; padding: 20px 0"
          >
            <b-spinner />
          </div>
          <div class="contentTopAnything" v-else>
            <span
              v-for="(item, index) in topIngredientes"
              :key="index"
              class="rowTopAnything"
            >
              <span class="rank-pos">#{{ index + 1 }}</span>
              <span class="rank-name">{{ item.nome }}</span>
              <span class="rank-total">{{ item.total }}</span>
            </span>
            <span v-if="topIngredientes.length === 0" class="rowTopAnything empty">
              Nenhum dado encontrado
            </span>
          </div>
        </div>
      </section>
    </main>

    <b-modal
      id="modal-detalhes-atualizacao-mobile"
      centered
      hide-footer
      :title="
        updateSelecionada
          ? obterEstiloTipo(updateSelecionada.tipo).texto
          : 'Detalhes'
      "
    >
      <div v-if="updateSelecionada" class="update-modal-body">
        <div class="update-modal-meta">
          <span>{{ formatarData(updateSelecionada.data) }}</span>
          <span>{{ obterEstiloTipo(updateSelecionada.tipo).texto }}</span>
        </div>
        <p>{{ updateSelecionada.textoAtualizacao }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import api from "../../services/axios";
import { DateTime } from "luxon";
import { mapState } from "vuex";

import Cash from "../../assets/dash-coin.svg";
import Recepit from "../../assets/dash-receipt.svg";
import Fiscal from "../../assets/dash-fiscal.svg";
import Group from "../../assets/dash-group.svg";
import Chart from "../../assets/dash-chart.svg";
import Mega from "../../assets/dash-mega.svg";
import serviceCompendio from "../../services/serviceCompendio";

export default {
  data() {
    return {
      Cash,
      Recepit,
      Fiscal,
      Group,
      Chart,
      Mega,
      weather: {},
      weatherMessage: "Localizando...",
      apiKey: "8ebfee51658e4df7b5ab27454d460709",
      formattedDate: this.getFormattedDate(),
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      countFinalizado: 0,
      countHoje: 0,
      totalProdutos: 0,
      totalClientes: 0,
      novosClientes: 0,
      mediaDia: 0,
      topCulturas: [],
      topIngredientes: [],
      updates: [],
      loading: false,
      updateSelecionada: null,
      spinGeneral: false,
    };
  },
  methods: {
    abrirModalAtualizacao(item) {
      this.updateSelecionada = item;
      this.$bvModal.show("modal-detalhes-atualizacao-mobile");
    },
    async findUpdate() {
      try {
        this.loading = true;
        const { data } = await serviceCompendio.findUpdates();
        this.updates = data || [];
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar atualizações",
          type: "info",
        });
      } finally {
        this.loading = false;
      }
    },
    formatarData(dataIso) {
      if (!dataIso) return "";
      const [ano, mes, dia] = dataIso.split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    getUpdateDay(dataIso) {
      if (!dataIso) return "--";
      return dataIso.split("T")[0].split("-")[2];
    },
    getUpdateMonth(dataIso) {
      if (!dataIso) return "---";
      const month = dataIso.split("T")[0].split("-")[1];
      const months = {
        "01": "JAN",
        "02": "FEV",
        "03": "MAR",
        "04": "ABR",
        "05": "MAI",
        "06": "JUN",
        "07": "JUL",
        "08": "AGO",
        "09": "SET",
        "10": "OUT",
        "11": "NOV",
        "12": "DEZ",
      };
      return months[month] || "---";
    },
    obterEstiloTipo(tipo) {
      const mapeamento = {
        A: { texto: "Alteração", classe: "tipo-alteracao" },
        I: { texto: "Inclusão", classe: "tipo-inclusao" },
        E: { texto: "Exclusão", classe: "tipo-exclusao" },
      };

      return (
        mapeamento[tipo] || { texto: "Atualização", classe: "tipo-alteracao" }
      );
    },
    getWeather(lat, lon) {
      const url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${this.apiKey}&units=metric&lang=pt_br`;
      axios
        .get(url)
        .then((res) => {
          this.weather = res.data;
        })
        .catch(() => {
          this.weatherMessage = "Erro ao carregar clima.";
        });
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => this.getWeather(pos.coords.latitude, pos.coords.longitude),
          () => {
            this.weatherMessage = "Sem permissão de localização.";
            this.getWeather(-15.7801, -47.9292);
          }
        );
      } else {
        this.weatherMessage = "Geolocalização não suportada.";
      }
    },
    getFormattedDate() {
      const options = { weekday: "long", day: "numeric", month: "long" };
      return new Date().toLocaleDateString("pt-BR", options);
    },
    async getReceipts() {
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
      try {
        this.spinGeneral = true;
        const { data } = await api.get(
          `/sales/count/status?q=${this.textPesquisa}&type=${this.type}&startDate=${this.startDate}&endDate=${this.endDate}&typeSale=Receita`
        );
        if (data) {
          this.countFinalizado = data.countFinalizado;
          this.countHoje = data.countHoje;
          this.totalProdutos = data.totalProdutos;
          this.totalClientes = data.totalClientes;
          this.novosClientes = data.novosClientes;
          this.topCulturas = data.topCulturas;
          this.topIngredientes = data.topIngredientes;
          const diasPassados = DateTime.local().day;
          const divisao = this.countFinalizado / diasPassados;
          this.mediaDia = divisao < 1 ? 1 : Math.round(divisao);
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
  },
  created() {
    this.getLocation();
    this.getReceipts();
    this.findUpdate();
  },
  computed: {
    ...mapState(["dataCompany"]),
    visibleUpdates() {
      return this.updates.slice(0, 4);
    },
    weatherIconType() {
      if (!this.weather.weather) return "cloud";

      const condition = this.weather.weather[0].main.toLowerCase();
      const icon = this.weather.weather[0].icon;

      if (condition.includes("clear")) {
        return icon.includes("d") ? "sun" : "moon";
      }
      if (condition.includes("clouds")) return "cloud";
      if (condition.includes("rain") || condition.includes("drizzle")) return "rain";
      if (condition.includes("thunderstorm")) return "storm";
      if (condition.includes("snow")) return "snow";
      if (condition.includes("mist") || condition.includes("fog")) return "mist";

      return "cloud";
    },
    weatherClass() {
      if (!this.weather.weather) return "weather-default";
      const condition = this.weather.weather[0].main.toLowerCase();
      const icon = this.weather.weather[0].icon;
      if (condition.includes("clear")) {
        return icon.includes("d") ? "weather-clear-day" : "weather-clear-night";
      }
      if (condition.includes("clouds")) {
        return icon.includes("d")
          ? "weather-clouds-day"
          : "weather-clouds-night";
      }
      if (condition.includes("rain") || condition.includes("drizzle")) {
        return "weather-rain";
      }
      if (condition.includes("thunderstorm")) return "weather-thunderstorm";
      if (condition.includes("snow")) return "weather-snow";
      if (condition.includes("mist") || condition.includes("fog")) {
        return "weather-mist";
      }
      return "weather-default";
    },
  },
};
</script>

<style scoped>
.mobile-dashboard {
  width: 100%;
  min-height: 100vh;
  background: #f3f6f5;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  overflow-x: hidden;
  padding-bottom: 88px;
  box-sizing: border-box;
}

.weather-hero {
  position: relative;
  color: white;
  margin: 10px 10px 0;
  padding: 14px;
  border-radius: 12px;
  box-shadow: 0 10px 22px rgba(0, 98, 86, 0.2);
  overflow: hidden;
  box-sizing: border-box;
}

.hero-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 9px;
  padding-right: 46px;
}

.logoSideApp {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  background: white;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.16);
}

.nameCompany {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.nameCompany small {
  font-size: 10px;
  opacity: 0.82;
  line-height: 1.1;
}

.nameCompany span {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 800;
}

.weather-content {
  position: relative;
  z-index: 1;
  margin-top: 14px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 12px;
  align-items: end;
}

.weather-text {
  display: flex;
  flex-direction: column;
}

.weather-text .city {
  font-size: 15px;
  font-weight: 800;
}

.weather-text .date {
  font-size: 10px;
  opacity: 0.86;
  text-transform: capitalize;
}

.weather-summary {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
  grid-row: span 2;
}

.weather-symbol {
  width: 38px;
  height: 38px;
  color: #ffd166;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.weather-symbol svg {
  width: 24px;
  height: 24px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.22));
}

.weather-temp-big {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  text-align: right;
}

.weather-desc {
  font-size: 10px;
  text-transform: capitalize;
  text-align: right;
  opacity: 0.9;
  max-width: 78px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.weather-details {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  margin-top: 12px;
  grid-column: 1 / -1;
}

.weather-details span {
  height: 30px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background: rgba(255, 255, 255, 0.14);
  color: white;
  font-size: 10px;
  font-weight: 700;
}

.weather-loading {
  min-height: 120px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.weather-loading p {
  margin: 0;
  font-size: 13px;
}

.weather-default,
.weather-clear-day,
.weather-clouds-day {
  background: linear-gradient(135deg, #006256 0%, #007669 100%);
}

.weather-clear-night,
.weather-clouds-night,
.weather-rain,
.weather-thunderstorm,
.weather-snow,
.weather-mist {
  background: linear-gradient(135deg, #004c43 0%, #006256 100%);
}

.main-content {
  width: 100%;
  padding: 16px 14px 0;
  box-sizing: border-box;
}

.section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 18px 2px 10px;
}

.section-title {
  font-size: 16px;
  line-height: 1.1;
  color: #1e2927;
  font-weight: 800;
  margin: 0;
}

.section-subtitle {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  color: #7b8784;
  font-weight: 500;
}

.kpi-scroll-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.kpi-card {
  min-height: 132px;
  background: white;
  border: 1px solid #e7ecea;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 8px 22px rgba(18, 38, 34, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.kpi-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-box {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-box img {
  width: 19px;
  height: 19px;
  filter: brightness(0) saturate(100%);
  opacity: 0.95;
}

.green-bg {
  background: #d8f0e4;
}

.green-bg img {
  filter: brightness(0) saturate(100%) invert(28%) sepia(78%) saturate(694%)
    hue-rotate(128deg) brightness(85%) contrast(101%);
}

.blue-bg {
  background: #dbeafe;
}

.blue-bg img {
  filter: brightness(0) saturate(100%) invert(38%) sepia(42%) saturate(1176%)
    hue-rotate(180deg) brightness(85%) contrast(91%);
}

.amber-bg {
  background: #ffebc2;
}

.amber-bg img {
  filter: brightness(0) saturate(100%) invert(51%) sepia(91%) saturate(538%)
    hue-rotate(2deg) brightness(91%) contrast(92%);
}

.teal-bg {
  background: #ccebe8;
}

.teal-bg img {
  filter: brightness(0) saturate(100%) invert(30%) sepia(53%) saturate(683%)
    hue-rotate(130deg) brightness(86%) contrast(94%);
}

.kpi-label {
  font-size: 11px;
  color: #6b7774;
  font-weight: 700;
  line-height: 1.25;
}

.kpi-value {
  font-size: 30px;
  font-weight: 900;
  color: #10201d;
  line-height: 1;
  margin-top: 10px;
}

.kpi-footer {
  font-size: 11px;
  color: #8a9692;
  margin: 8px 0 0;
  line-height: 1.35;
}

.kpi-footer.warning {
  color: #b56a00;
  font-weight: 800;
}

.kpi-footer.success {
  color: #007767;
  font-weight: 800;
}

.updates-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.update-item {
  width: 100%;
  min-height: 96px;
  background: white;
  border: 1px solid #e7ecea;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 8px 22px rgba(18, 38, 34, 0.06);
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
}

.update-date-pill {
  width: 46px;
  height: 58px;
  border-radius: 9px;
  background: #006256;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.update-date-pill span {
  font-size: 19px;
  font-weight: 900;
  line-height: 1;
}

.update-date-pill small {
  margin-top: 4px;
  font-size: 10px;
  font-weight: 800;
  opacity: 0.85;
}

.update-content {
  min-width: 0;
  flex: 1;
}

.update-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.update-tag {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-height: 22px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  color: #006256;
  background: #e0f2f1;
}

.tipo-inclusao {
  color: #006256;
  background: #e0f2f1;
}

.tipo-alteracao {
  color: #315f99;
  background: #e8f0fb;
}

.tipo-exclusao {
  color: #9c3d2f;
  background: #fdebe8;
}

.update-arrow {
  color: #006256;
  flex-shrink: 0;
}

.update-content p {
  margin: 0;
  color: #3e4b48;
  font-size: 12px;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.updates-state {
  min-height: 78px;
  border: 1px dashed #cfd8d5;
  border-radius: 10px;
  color: #66736f;
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
}

.ranking-card {
  width: 100%;
  background: white;
  border: 1px solid #e7ecea;
  border-radius: 10px;
  box-shadow: 0 8px 22px rgba(18, 38, 34, 0.06);
  margin-bottom: 12px;
  overflow: hidden;
  box-sizing: border-box;
}

.ranking-title {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 900;
  color: white;
  background: #006256;
  padding: 11px 12px;
  box-sizing: border-box;
  line-height: 1.35;
}

.cash-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.contentTopAnything {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px;
  gap: 6px;
  box-sizing: border-box;
}

.rowTopAnything {
  width: 100%;
  min-height: 38px;
  font-size: 12px;
  padding: 7px 8px;
  font-weight: 700;
  color: #1f2927;
  background: #f7faf9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 7px;
  box-sizing: border-box;
}

.rowTopAnything.empty {
  justify-content: center;
  color: #8a9692;
  font-weight: 600;
}

.rank-pos {
  font-weight: 900;
  color: #006256;
  min-width: 30px;
  flex-shrink: 0;
}

.rank-name {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: capitalize;
}

.rank-total {
  min-width: 30px;
  height: 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  font-weight: 900;
  color: #006256;
  background: #e0f2f1;
  flex-shrink: 0;
}

.update-modal-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.update-modal-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.update-modal-meta span {
  border-radius: 999px;
  background: #e0f2f1;
  color: #006256;
  font-size: 11px;
  font-weight: 800;
  padding: 4px 9px;
}

.update-modal-body p {
  margin: 0;
  white-space: pre-wrap;
  color: #3e4b48;
  font-size: 13px;
  line-height: 1.6;
}

@media (max-width: 360px) {
  .kpi-scroll-container {
    grid-template-columns: 1fr;
  }

  .weather-details {
    grid-template-columns: 1fr;
  }
}
</style>
